import React, { type ReactNode } from 'react';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { Flex, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

type Props = {
	errorMessage: ReactNode;
};

export const SidebarError = ({ errorMessage }: Props) => {
	return (
		<Flex direction="column" alignItems="center" justifyContent="center" xcss={containerStyles}>
			<Text align="center">
				<WarningIcon primaryColor={token('color.icon.warning')} size="small" label="" />
				{errorMessage}
			</Text>
		</Flex>
	);
};

const containerStyles = xcss({
	paddingTop: 'space.800',
	paddingBottom: 'space.800',
});
